<template>
    <div class="app-container">
        <el-row>
            <el-col :span="10">
                <el-button type="primary" icon="el-icon-plus" size="small" @click="openAddMateriel" >{{$t('base.materiel.create')}}</el-button>
                <el-button type="primary" icon="el-icon-upload" size="small" plain @click="downMaterielTemplate">{{$t('commons.importTemplate')}}</el-button>
                <el-button type="primary" icon="el-icon-upload2" size="small" plain @click="uploadModel = true">{{$t('commons.import')}}</el-button>
                <el-button type="primary" icon="el-icon-download" plain size="small" @click="exportMateriel">{{$t('commons.export')}}</el-button>
            </el-col>
            <el-col :span="6" :offset="8">
                <div class="filter-container" align="right">
                    <el-input :placeholder="$t('commons.searchPhrase')"
                              clearable
                              maxlength="50"
                              v-model="materiel.listQuery.searchPhrase"
                              size="small" style="width: 200px;" class="filter-item"
                              @keyup.enter.native="searchCondition"/>
                    <el-button size="small" class="filter-item" type="primary" :loading="materiel.listLoading"
                               icon="el-icon-search" @click="searchCondition">
                        {{$t('commons.search') }}
                    </el-button>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-table
                    v-loading="materiel.listLoading"
                    :data="materiel.list"
                    element-loading-text="loading"
                    border
                    fit
                    highlight-current-row
                    stripe>
                <el-table-column :label="$t('base.project.name')">
                    <template slot-scope="scope">
                        <span>{{ scope.row.projectName }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('base.materiel.name')">
                    <template slot-scope="scope">
                        <span>{{ scope.row.materielName }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('base.materiel.code')">
                    <template slot-scope="scope">
                        <span>{{ scope.row.materielCode }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('base.materiel.type')">
                    <template slot-scope="scope">
                        <span>{{ scope.row.materielCategoryName }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('commons.lastUpdateDate')">
                    <template slot-scope="scope">
                        <i class="el-icon-time"/>
                        <span v-if="scope.row.lastUpdateDate != null"> {{ scope.row.lastUpdateDate | dateFormat('YYYY-MM-DD HH:mm:ss') }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="100" :label="$t('commons.actions')">
                    <template slot-scope="scope">
                        <el-tooltip :content="$t('commons.edit')" placement="bottom" :open-delay="openDelay">
                            <el-button
                                    size="mini"
                                    icon="el-icon-edit"
                                    type="primary"
                                    circle
                                    :disabled="scope.row.processing"
                                    @click="openUpdateMateriel(scope.row)">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content="$t('commons.delete')" placement="bottom" :open-delay="openDelay">
                            <el-button
                                    size="mini"
                                    icon="el-icon-delete"
                                    type="danger"
                                    circle
                                    :disabled="scope.row.processing"
                                    @click="deleteMateriel(scope.row)">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <pagination v-show="materiel.total>0" :total="materiel.total" :page.sync="materiel.listQuery.current"
                        :limit.sync="materiel.listQuery.rowCount"
                        @pagination="getMaterielPage"/>
        </el-row>

        <!-- 编辑物料对话框 -->
        <el-dialog :visible.sync="materiel.addDialogVisible"
                   :before-close="cancelMaterielSave" width="40%" :close-on-click-modal="false">
            <template slot="title">
                <title-icon/>{{ materiel.title }}
            </template>
            <el-form label-position="top" :model="materiel.form" ref="materielForm" :rules="materiel.formRules">
                <el-row>
                    <el-col :md="11">
                        <el-form-item :label="$t('base.materiel.materielName')" prop="materielName">
                            <el-input type="hidden" class="hidden" v-model="materiel.form.materielId" ></el-input>
                            <el-input v-model="materiel.form.materielName" maxlength="25" :show-word-limit="true" @input="setCode()" :placeholder="$t('commons.pleaseInput')" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :md="11" :offset="2">
                        <el-form-item :label="$t('base.materiel.code')" prop="materielCode">
                            <el-input v-model="materiel.form.materielCode" maxlength="16" :show-word-limit="true" :placeholder="$t('commons.pleaseInput')" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :md="11">
                        <el-form-item :label="$t('base.project.name')" prop="projectId">
                            <el-select v-model="materiel.form.projectId" class="maxWidth" clearable :placeholder="$t('commons.selectPlease')">
                                <el-option v-for="item in materiel.projectList"
                                           :key="item.projectId"
                                           :label="item.projectName"
                                           :value="item.projectId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :md="11" :offset="2">
                        <el-form-item :label="$t('base.materiel.type')" prop="materielCategoryId">
                            <el-select v-model="materiel.form.materielCategoryId" class="maxWidth" clearable :placeholder="$t('commons.selectPlease')">
                                <el-option v-for="item in materiel.materielCategoryList"
                                           :key="item.materielCategoryId"
                                           :label="item.materielCategoryName"
                                           :value="item.materielCategoryId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :md="11">
                        <el-form-item :label="$t('base.materiel.mode')" prop="currentModel">
                            <el-input v-model="materiel.form.currentModel" maxlength="33" :show-word-limit="true" :placeholder="$t('commons.pleaseInput')" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :md="11" :offset="2">
                        <el-form-item :label="$t('base.materiel.unit')" prop="materielUnit">
                            <el-input v-model="materiel.form.materielUnit" maxlength="33" :show-word-limit="true" :placeholder="$t('commons.pleaseInput')" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item :label="$t('base.materiel.label')" prop="materielId">
                            <tag-bind :tagValueList="materiel.form.tagList" tagType="materiel"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item :label="$t('base.materiel.desc')" prop="description">
                            <el-input type="textarea" :rows="3" v-model="materiel.form.description" maxlength="160" :show-word-limit="true" :placeholder="$t('commons.pleaseInput')" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer">
                <el-button @click="cancelMaterielSave">{{$t('commons.cancel') }}</el-button>
                <el-button type="primary" @click="handleMaterielSave"
                           v-loading.fullscreen.lock="materiel.createLoading">{{$t('commons.save') }}
                </el-button>
            </div>
        </el-dialog>


        <!--导入文件-->
        <el-dialog :visible.sync="uploadModel" width="40%">
            <template slot="title">
                <title-icon/>{{ $t('commons.uploadFile') }}
            </template>
            <div slot="footer">
                <upload :ulType="uploadType" :excelType="excelType" :rootPath="rootPath" @success="uploadSuccess" @fail="uploadFail"></upload>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getMaterielPage,
        createMateriel,
        updateMateriel,
        deleteMateriel,
        getMaterielById,
        exportMateriel,
        downMaterielTemplate
    } from '@/api/business/base/tenant/materiel'
    import {
        getMaterielCategoryList,
    } from '@/api/business/base/tenant/materielcategory'
    import {
        getProjectList,
    } from '@/api/business/base/tenant/project'
    import TagBind from '@/components/TagBind'
    import Pagination from '@/components/Pagination'
    import pinyin from 'js-pinyin'

    import Upload from '@/components/Upload'
    import { envInfo } from '@/constants/envInfo'
    import store from '@/store/index'

    export default {
        name: "MaterielManager",
        components: {
            Pagination,
            TagBind,
            Upload
        },
        data() {
            return {
                uploadPath:envInfo.bgApp.archivePath+'/param/archive/upload?ulType=DefaultUpload',
                uploadModel: false,
                uploadType: "ExcelImport",
                excelType: "iori.materiel",
                rootPath: envInfo.bgApp.basePath,

                openDelay: 1000,
                materiel: {
                    materielCategoryList:[],
                    projectList:[],
                    title: null,
                    addDialogVisible: false,
                    list:[],
                    listLoading: false,
                    total: 0,
                    listQuery: {
                        current: 1,
                        rowCount: 10,
                        searchPhrase: null,
                    },
                    form:{
                        materielId: null,
                        materielCode: null,
                        materielName: null,
                        materielCategoryId: null,
                        materielCategoryName: null,
                        currentModel: null,
                        projectId: null,
                        projectName: null,
                        materielUnit:null,
                        description: null,
                        tagList:[],
                    },
                    formRules:{
                        materielName : [{
                            required: true,
                            trigger: ['blur', 'change'],
                            message: this.$t('validate.required')
                        }],
                        materielCode : [{
                            required: true,
                            trigger: ['blur', 'change'],
                            message: this.$t('validate.required')
                        }],
                        projectId : [{
                            required: true,
                            trigger: ['blur', 'change'],
                            message: this.$t('validate.required')
                        }],
                        materielCategoryId : [{
                            required: true,
                            trigger: ['blur', 'change'],
                            message: this.$t('validate.required')
                        }],
                        materielUnit : [{
                            required: true,
                            trigger: ['blur', 'change'],
                            message: this.$t('validate.required')
                        }],
                    }
                }
            }
        },
        created() {
            this.searchCondition();
            this.materielCategoryList();
            this.projectList();
        },
        methods:{
            setCode(){
                let name = this.materiel.form.materielName;
                this.materiel.form.materielCode = pinyin.getCamelChars(name);
            },
            searchCondition(){
                this.materiel.listQuery.current = 1;
                this.getMaterielPage()
            },
            getMaterielPage(){
                this.materiel.listLoading = true;
                getMaterielPage(this.materiel.listQuery).then(response =>{
                    this.materiel.total = response.total;
                    this.materiel.list = response.rows;
                    this.materiel.listLoading = false;
                });
            },
            materielCategoryList(){
                getMaterielCategoryList().then(response =>{
                    this.materiel.materielCategoryList = response;
                });
            },
            projectList(){
                getProjectList().then(response =>{
                    this.materiel.projectList = response;
                });
            },
            deleteMateriel(row){
                this.$confirm(this.$t('message.deleteConfirm'),this.$t('commons.warning'),{
                    confirmButtonText:this.$t('commons.confirm'),
                    cancelButtonText:this.$t('commons.cancel'),
                    type:'warning'
                }).then(()=>{
                    deleteMateriel({"materielId":row.materielId,"materielName":row.materielName}).then(()=>{
                        //成功提示
                        this.$message({
                            message:this.$t('message.deleteSuccess'),
                            type:'success'
                        })
                        //删除成功后重新渲染table
                        this.searchCondition()
                    }).catch(error =>{
                        console.log(`删除失败，原因 => ${error}`)
                    })
                }).catch(error =>{
                    console.log(`未删除，原因 => ${error}`)
                })
            },
            openAddMateriel(){
                this.clearMaterielForm();
                this.materiel.title = this.$t('base.materiel.create');
                this.materiel.addDialogVisible = true;
            },
            openUpdateMateriel(row){
                getMaterielById({"materielId":row.materielId}).then(res=>{
                    this.materiel.title = this.$t('base.materiel.edit');
                    this.materiel.form = res;
                    this.materiel.addDialogVisible = true;
                });
            },
            cancelMaterielSave(){
                this.materiel.addDialogVisible = false;
            },
            handleMaterielSave(){
                this.$refs.materielForm.validate(v=> {
                    if (v) {
                        //去重复
                        this.materiel.form.tagList = Array.from(new Set(this.materiel.form.tagList));
                        if(this.materiel.form.materielId == null){
                            createMateriel(this.materiel.form).then(()=>{
                                this.materiel.addDialogVisible = false;
                                //成功提示
                                this.$message({
                                    message:this.$t('message.operationSuccess'),
                                    type:'success'
                                })
                                this.getMaterielPage()
                            }).catch(error =>{
                                console.log(`保存失败，原因 => ${error}`)
                            })
                        }else{
                            updateMateriel(this.materiel.form).then(()=>{
                                this.materiel.addDialogVisible = false;
                                //成功提示
                                this.$message({
                                    message:this.$t('message.operationSuccess'),
                                    type:'success'
                                })
                                this.getMaterielPage()
                            }).catch(error =>{
                                console.log(`保存失败，原因 => ${error}`)
                            })
                        }
                    }
                })
            },
            clearMaterielForm(){
                this.materiel.form = {
                    materielId: null,
                    materielCode: null,
                    materielName: null,
                    materielCategoryId: null,
                    materielCategoryName: null,
                    currentModel: null,
                    projectId: null,
                    projectName: null,
                    materielUnit:null,
                    description: null,
                    tagList:[],
                };
                if (this.$refs.materielForm) {
                    this.$refs.materielForm.resetFields();
                }
            },
            exportMateriel(){
                exportMateriel(this.materiel.listQuery).then((msg)=>{
                    this.$message({type: 'success', message: this.$t('message.operationSuccess')});
                    let exportObj = {
                        taskId : msg,
                        taskName : "Materiel",
                        taskStatus : 0,
                        rootPath : 'basePath'
                    };
                    //将导出任务丢入导出任务列表中
                    store.dispatch('PushExportTaskList',exportObj);
                })
            },
            downMaterielTemplate(){
                downMaterielTemplate();
            },
            uploadSuccess(){
                //this.uploadModel = false
                this.$message({type: 'success', message: this.$t('message.uploadSuccess')});
            },
            uploadFail() {
                this.$message({type: 'error', message: this.$t('message.uploadFial')});
            },
        }
    }
</script>

<style scoped>
.maxWidth{
    width: 100%;
}
</style>
